import * as React from 'react';
import { TPhoneCases } from './PhoneCases.types';
import { Button } from 'components';
import { Add } from '@mui/icons-material';
import '../../AdminPanel.styles.scss';
import { MODALS } from 'store/contexts/ModalContext/modals';
import { useModals } from 'hooks/useModals';
import { PhoneCasesTable } from './components/PhoneCasesTable/PhoneCasesTable';
import { useAppDispatch } from 'store/store';
import { getTagsListAsyncThunk } from 'store/tags/tags.action';
import { resetTagsList } from 'store/tags/tags.slices';

export const PhoneCases: TPhoneCases = () => {
  const modals = useModals();
  const dispatch = useAppDispatch();

  const openModal = () => {
    modals.openModal(MODALS.ADMIN_PHONE_CASE_ADD);
  };

  // Load tags when form opens
  React.useEffect(() => {
    dispatch(getTagsListAsyncThunk());
    return () => {
      dispatch(resetTagsList());
    };
  }, [dispatch]);

  return (
    <div className="admin-entity">
      <div className="admin-entity__header">
        <div>
          <h4>Phone cases</h4>
        </div>
        <div className="admin-entity__header__buttons-contaier">
          <Button variant="contained" endIcon={<Add />} onClick={openModal}>
            Add phone case
          </Button>
        </div>
      </div>
      <PhoneCasesTable />
    </div>
  );
};
